"use client";

import Link from 'next/link';
import { useEffect, useState } from 'react';
import { NavItem } from "@/utils/types";
import { normSlug } from "@/utils/tools";

const dropdownNavs: any = {
	"About": [
		{
			title: "Reviews",
			path: "/"
		},
		{
			title: "Our Blog",
			path: "/"
		},
		{
			title: "Specials",
			path: "/"
		},
		{
			title: "Our Team",
			path: "/"
		},
		{
			title: "FAQ",
			path: "/"
		},
		{
			title: "Contact",
			path: "/"
		},
	],
	"Landing Pages": [],
	"Locations": [],
	"We Are The Digital Shop": [
		{
			title: "What is SmartFlow?",
			path: "/"
		},
		{
			title: "Digital Inspections",
			path: "/"
		},
	]
}

export default function NavBar({ data }: any)
{

	const name: string | null | undefined = data?.info?.name;
	const city: string | null | undefined = data?.info?.city;
	const address: string | null | undefined = data?.info?.address;
	const phone: string | null | undefined = data?.info?.phone_number;
	const st: string | null | undefined = data?.info?.state;

	const [state, setState] = useState(false)
	const [DropdownState, setDropdownState] = useState<any>({ isActive: false, idx: null })

	dropdownNavs["Landing Pages"] = data?.landings?.map((x: NavItem) =>
	{
		x.title = x.name;
		x.path = `/landing/${x.slug}`;
		return x
	}) ?? [];
	dropdownNavs["Locations"] = data?.Locations;

	const navigation = [
		{ title: "Home", path: "/", isDropdown: false },
		{ title: "Services", path: "/services", isDropdown: false },
		{ title: "Service Videos", path: "service-videos", isDropdown: false },
		{ title: "About", path: "#", isDropdown: true, dropNavs: dropdownNavs },
		{ title: "Contact", path: "#", isDropdown: false }
	]

	useEffect(() =>
	{
		document.onclick = (e) =>
		{

			const target = e.target as HTMLElement;
			if (!target.closest(".nav-menu")) setDropdownState({ isActive: false, idx: null });
		};
	}, [])

	return (

		<>
			<nav className={`relative z-20 w-full md:static md:text-sm md:border-none`}>
				<div className=" items-center px-4 md:px-8 mx-auto md:flex">
					<div className={`flex items-center justify-between py-3 md:py-5 md:block`}>

						{/* Logo */}
						<Link href="/" title="DSX Next Prototype" aria-label="DSX Next Prototype">
							<svg className="md:-ml-4 mr-8 fill-neutral-800" width="214" height="48" viewBox="0 0 214 48" xmlns="http://www.w3.org/2000/svg">
								<path fillRule="evenodd" clipRule="evenodd" d="M61.4593 34.488H64.2432C64.6611 34.488 65.0202 34.6733 65.2287 34.9964C65.4329 35.3132 65.4537 35.7199 65.2845 36.0841L62.9522 41.1641L60.3677 47.2192C60.2548 47.4401 59.9648 48 59.1602 48H59.142L58.2302 47.9797C57.7084 47.9745 57.2851 47.7011 57.045 47.2095L56.9993 47.0696L56.4023 43.7996L50.6476 14.3069L45.6103 29.246L43.4064 36.253C43.1375 36.7296 42.7022 36.9736 42.1679 36.9503L41.6729 36.9524C40.826 36.91 40.5681 36.3274 40.4835 36.1356L38.4219 31.4954L35.7624 26.0985L32.1618 29.0133C31.8633 29.2551 31.5187 29.4193 31.1458 29.4998C31.1458 29.4998 30.7738 29.5754 30.28 29.5415L0.326972 27.6648C0.326972 27.6648 0 27.6038 0 27.1137C0 26.6233 0.345871 26.5435 0.345871 26.5435L29.6514 24.7097L32.4936 22.4092L35.6035 19.6514C35.7001 19.5426 36.113 19.0934 36.6977 19.0934H36.7034L37.0177 19.0921C37.8642 19.1345 38.1225 19.7165 38.2078 19.9086V19.9089L38.7765 21.0658C38.7893 21.0742 38.8153 21.1159 38.8376 21.1605L41.3791 26.3205L48.6861 4.65368L49.9634 0.698607C50.2326 0.222683 50.6755 -0.0227227 51.2011 0.00209361L51.8072 0C52.6537 0.0423531 52.9116 0.62504 52.9962 0.816624L53.0313 0.927028L53.6781 4.08015C53.6909 4.11056 53.706 4.15226 53.7158 4.2018L54.0424 5.85289L54.0405 5.86493L59.8791 35.7891L60.0309 35.4469C60.2748 34.9612 60.6252 34.488 61.4593 34.488ZM155.216 9.98063C155.738 9.50131 156.416 9.26007 157.249 9.26007C158.081 9.26007 158.759 9.49137 159.282 9.9524C159.805 10.4134 160.066 10.9898 160.066 11.6814C160.066 12.431 159.805 13.0504 159.282 13.5405C158.759 14.0305 158.081 14.2759 157.249 14.2759C156.416 14.2759 155.738 14.0354 155.216 13.5553C154.693 13.0752 154.431 12.479 154.431 11.7683C154.431 11.0577 154.693 10.4615 155.216 9.98063ZM73.455 16.3513L70.2312 24.0754H76.6792L73.455 16.3513ZM62.0985 31.9445L71.1608 11.7683H75.8077L84.8987 31.9445H79.9615L78.1604 27.621H68.7209L66.9202 31.9445H62.0985ZM96.0521 27.2321C96.7099 26.5307 97.0395 25.4882 97.0395 24.1045V16.4375H101.57V31.9446H97.2717V30.0996C96.6714 30.7728 95.9547 31.287 95.1225 31.6418C94.2896 31.9976 93.3894 32.1751 92.4213 32.1751C90.3688 32.1751 88.7421 31.5888 87.5418 30.4171C86.3411 29.2454 85.7411 27.5058 85.7411 25.1998V16.4375H90.2721V24.5371C90.2721 27.0349 91.3271 28.2837 93.4377 28.2837C94.5222 28.2837 95.3936 27.9336 96.0521 27.2321ZM112.23 28.6012C111.61 28.6012 111.131 28.4237 110.792 28.068C110.453 27.7122 110.284 27.208 110.284 26.5547V20.2421H114.176V16.7834H110.284V13.0073H105.753V16.7834H103.342V20.2421H105.753V26.612C105.753 28.4379 106.261 29.8216 107.278 30.763C108.294 31.7049 109.732 32.1751 111.591 32.1751C112.307 32.1751 112.99 32.093 113.638 31.9304C114.287 31.767 114.834 31.5224 115.279 31.195L114.06 28.0248C113.556 28.4088 112.946 28.6012 112.23 28.6012ZM124.196 28.486C125.358 28.486 126.311 28.0963 127.057 27.3184C127.802 26.5398 128.175 25.4982 128.175 24.1908C128.175 22.8847 127.802 21.8416 127.057 21.0638C126.311 20.2852 125.358 19.8963 124.196 19.8963C123.034 19.8963 122.076 20.2852 121.321 21.0638C120.565 21.8416 120.187 22.8847 120.187 24.1908C120.187 25.4982 120.565 26.5398 121.321 27.3184C122.076 28.0963 123.034 28.486 124.196 28.486ZM124.196 16.2071C125.842 16.2071 127.313 16.548 128.611 17.2304C129.908 17.9128 130.925 18.8589 131.661 20.0695C132.396 21.2801 132.764 22.6542 132.764 24.1908C132.764 25.7288 132.396 27.102 131.661 28.3127C130.925 29.5233 129.908 30.4702 128.611 31.1519C127.313 31.8342 125.842 32.1751 124.196 32.1751C122.55 32.1751 121.073 31.8342 119.766 31.1519C118.46 30.4702 117.438 29.5233 116.702 28.3127C115.966 27.102 115.599 25.7288 115.599 24.1908C115.599 22.6542 115.966 21.2801 116.702 20.0695C117.438 18.8589 118.46 17.9128 119.766 17.2304C121.073 16.548 122.55 16.2071 124.196 16.2071ZM142.959 26.1799L136.773 11.7683H131.689L140.461 31.9445H145.108L153.908 11.7683H149.233L142.959 26.1799ZM154.984 31.9445H159.514V16.4376H154.984V31.9445ZM168.736 28.068C169.075 28.4237 169.554 28.6012 170.174 28.6012C170.89 28.6012 171.5 28.4088 172.003 28.0248L173.223 31.195C172.778 31.5224 172.231 31.767 171.582 31.9304C170.933 32.093 170.251 32.1751 169.534 32.1751C167.676 32.1751 166.238 31.7049 165.221 30.763C164.205 29.8216 163.697 28.4379 163.697 26.612V20.2421H161.286V16.7834H163.697V13.0073H168.228V16.7834H172.12V20.2421H168.228V26.5547C168.228 27.208 168.397 27.7122 168.736 28.068ZM184.493 27.0448C184.24 27.7364 183.814 28.2604 183.214 28.6153C182.614 28.971 181.927 29.1485 181.152 29.1485C180.358 29.1485 179.734 28.9809 179.279 28.6443C178.824 28.3085 178.596 27.8516 178.596 27.2753C178.596 26.0646 179.526 25.4593 181.385 25.4593H184.493V27.0448ZM181.501 16.2071C180.242 16.2071 179.018 16.3705 177.827 16.6972C176.636 17.0239 175.615 17.4849 174.763 18.0804L176.389 21.2221C176.951 20.7802 177.633 20.4294 178.437 20.1699C179.24 19.9104 180.059 19.781 180.892 19.781C182.092 19.781 182.992 20.0455 183.592 20.5737C184.192 21.1027 184.493 21.8564 184.493 22.8365H180.892C178.606 22.8365 176.917 23.2495 175.823 24.0754C174.728 24.9021 174.182 26.0357 174.182 27.4768C174.182 28.3805 174.414 29.1874 174.879 29.898C175.343 30.6094 176.016 31.166 176.898 31.5698C177.778 31.9737 178.819 32.1752 180.02 32.1752C182.344 32.1752 183.931 31.4545 184.783 30.0134V31.9445H189.024V23.096C189.024 20.7901 188.375 19.0653 187.078 17.9219C185.78 16.7791 183.921 16.2071 181.501 16.2071ZM197.069 31.9445H192.538V10.5577H197.069V31.9445ZM212.433 24.5945C211.833 23.9602 211.126 23.5239 210.313 23.2828C209.5 23.0431 208.454 22.8174 207.176 22.606C206.033 22.4327 205.201 22.2503 204.678 22.0579C204.155 21.8664 203.894 21.5298 203.894 21.0496C203.894 20.6268 204.136 20.281 204.62 20.0115C205.104 19.7428 205.83 19.6078 206.798 19.6078C208.425 19.6078 209.925 19.9924 211.3 20.7611L212.811 17.5612C212.094 17.1391 211.189 16.8075 210.096 16.567C209.001 16.3273 207.902 16.2071 206.798 16.2071C205.307 16.2071 204.015 16.4186 202.921 16.8407C201.827 17.2636 200.994 17.8547 200.423 18.6134C199.851 19.3729 199.566 20.2421 199.566 21.2221C199.566 22.3946 199.871 23.2977 200.481 23.932C201.091 24.5655 201.813 25.0082 202.645 25.2578C203.478 25.5074 204.533 25.7288 205.811 25.9204C206.895 26.0547 207.699 26.2188 208.222 26.4105C208.745 26.6028 209.006 26.9196 209.006 27.3616C209.006 28.3035 208.048 28.7738 206.131 28.7738C205.181 28.7738 204.214 28.6352 203.226 28.3559C202.239 28.0778 201.396 27.7172 200.699 27.2753L199.189 30.5033C199.924 30.9843 200.912 31.3824 202.152 31.6999C203.39 32.0167 204.658 32.1751 205.956 32.1751C207.485 32.1751 208.807 31.9686 209.921 31.5555C211.034 31.1426 211.881 30.5607 212.463 29.8119C213.043 29.0622 213.333 28.2073 213.333 27.2463C213.333 26.1128 213.033 25.2288 212.433 24.5945Z" />
							</svg>
						</Link>

						{/* Mobile burger */}
						<div className="md:hidden">
							<button className="text-neutral-500 hover:text-neutral-800" aria-label="Main navigation" title="Main navigation"
								onClick={() => setState(!state)}
							>
								{
									state ? (
										// Cross
										<svg className="stroke-neutral-800" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
											<path d="M4 4L20.9706 20.9706" strokeWidth="2" strokeLinecap="square" />
											<path d="M3.51465 21L20.4852 4.02944" strokeWidth="2" strokeLinecap="square" />
										</svg>
									) : (
										// Burger
										<svg className="stroke-neutral-800" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M0 16H24" strokeWidth="2" strokeLinecap="square" />
											<path d="M0 8H24" strokeWidth="2" strokeLinecap="square" />
										</svg>
									)
								}
							</button>
						</div>
					</div>

					<div className={`nav-menu pb-4 mt-8 md:block md:pb-0 md:mt-0 ${state ? 'block' : 'hidden'}`}>
						<ul className="items-center space-y-6 md:flex md:space-x-6 md:space-y-0">

							{/* Menu */}
							{
								navigation.map((item, idx) =>
								{
									return (
										<li key={idx}>
											{
												item.isDropdown ? (
													<button className="w-full flex items-center justify-between gap-1 text-neutral-700 hover:text-primary-600"
														onClick={() => setDropdownState({ isActive: !DropdownState.isActive, idx: idx })}
													>
														{item.title}
														{
															DropdownState.idx == idx && DropdownState.isActive ? (
																<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
																	<path fillRule="evenodd" d="M14.77 12.79a.75.75 0 01-1.06-.02L10 8.832 6.29 12.77a.75.75 0 11-1.08-1.04l4.25-4.5a.75.75 0 011.08 0l4.25 4.5a.75.75 0 01-.02 1.06z" clipRule="evenodd" />
																</svg>

															) : (
																<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
																	<path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
																</svg>
															)
														}
													</button>
												) : (
													<a href={item.path} className="block text-neutral-700 hover:text-primary-600">
														{item.title}
													</a>
												)
											}
											{
												item.isDropdown && DropdownState.idx == idx && DropdownState.isActive ? (
													<div className="mt-6 inset-x-0 z-10 bg-[#FFFEFC] w-full md:absolute md:border-y md:shadow-md">
														<ul className='max-w-(--breakpoint-xl) mx-auto grid items-top gap-6 md:p-8 md:grid-cols-2 lg:grid-cols-4'>
															{
																Object.keys(item.dropNavs).map((k: string, index: number) =>
																{
																	let nItem = item.dropNavs[k];
																	return (
																		<li key={k}>
																			<p className="text-neutral-600 text-lg"><b>{k}</b></p>
																			<ul className='mt-5 space-y-3'>
																				{nItem.map((navItem: any, idx: number) => (
																					<li key={idx}>
																						<a href={navItem.path} className='flex gap-3 items-center'>{navItem.title}</a>
																					</li>
																				))}
																			</ul>
																		</li>
																	)
																})
															}
														</ul>
													</div>
												) : ""
											}
										</li>
									)
								})
							}

							<hr className="max-w-(--breakpoint-xl) mx-auto border-neutral-300 dark:border-neutral-700" />

							{/* Mobile contacts */}
							<div className='flex flex-wrap sm:flex-nowrap text-neutral-500 text-xs justify-between space-y-3 sm:space-y-0 md:hidden md:space-y-0'>
								<a href="#" rel="noopener noreferrer" className="md:items-center items-top gap-2 flex w-full sm:w-1/4">
									<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-neutral-400">
										<path strokeLinecap="round" strokeLinejoin="round" d="M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3" />
									</svg>
									<span className="hover:underline focus-visible:underline">{phone}</span>
								</a>
								<a href="#" rel="noopener noreferrer" className="md:items-center items-top gap-2 flex w-full sm:w-1/3">
									<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-neutral-400">
										<path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
										<path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
									</svg>
									<span className="hover:underline focus-visible:underline">{address + ', ' + city + ', ' + st}</span>
								</a>
								<a href="#" rel="noopener noreferrer" className="md:items-center items-top gap-2 flex w-full sm:w-max">
									<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-neutral-400">
										<path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
									</svg>
									<span className="hover:underline focus-visible:underline">Sun–Mon: 12.00–18.00, Tue–Fri: 9.00–19.00, Sat: 10.00–18.00</span>
								</a>
							</div>

						</ul>
					</div>

					{/* Button */}
					<div className={`items-center py-8 ml-auto md:space-y-0 md:block ${state ? 'block' : 'hidden'}`}>
						<a href="#" className="block py-3 px-4 font-medium text-center text-primary-500 border-primary-500 hover:text-primary-700 border-2 hover:border-primary-700 active:bg-primary-700 focus:outline-hidden focus:ring-3">
							Call Us
						</a>
					</div>
				</div>
			</nav>
			{
				state ? (
					<div
						className="z-10 fixed top-0 w-screen h-screen bg-white/20 backdrop-blur-xs md:hidden"
						onClick={() => setState(false)}></div>
				) : ""
			}
		</>
	)
}